__webpack_require__.p = "/event-reminders/account-setup/";